import React, { useState } from "react";
import { UserMinus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

// Coach's own team news — mark a player OUT / DOUBT / AVAILABLE; outranks the injury feed + web read, re-prices the number.
export const TeamNewsPanel = ({ teamName, oppName, onChanged }) => {
  const [club, setClub] = useState(teamName || "");
  const [player, setPlayer] = useState("");
  const [status, setStatus] = useState("OUT");
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const submit = async (e) => {
    e?.preventDefault?.();
    if (!player.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/availability", { team: club, player: player.trim(), status, reason: "coach's team news" });
      toast.success(r.data.note || `${player} marked ${status}`);
      setPlayer("");
      window.dispatchEvent(new CustomEvent("octon:team-news-changed"));
      onChanged?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not apply that team news");
    } finally { setBusy(false); }
  };
  if (!open) {
    return (
      <button onClick={() => setOpen(true)} data-testid="team-news-open" className="mt-2 inline-flex items-center gap-1.5 rounded-full border border-white/12 px-3 py-1 text-[11px] text-white/70 hover:border-cyan-400/40 hover:text-white">
        <UserMinus size={12} /> I have newer team news
      </button>
    );
  }
  return (
    <form onSubmit={submit} className="mt-2 flex flex-wrap items-center gap-2" data-testid="team-news-form">
      <select value={club} onChange={(e) => setClub(e.target.value)} data-testid="team-news-club" aria-label="Club" className="rounded-lg border border-white/12 bg-black/40 px-2 py-1 text-[12px] text-white/85">
        {[teamName, oppName].filter(Boolean).map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
      <input value={player} onChange={(e) => setPlayer(e.target.value)} placeholder="Player name" data-testid="team-news-player" aria-label="Player name"
        className="w-40 rounded-lg border border-white/12 bg-black/40 px-2 py-1 text-[12px] text-white/85 placeholder:text-white/30" />
      <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="team-news-status" aria-label="Status" className="rounded-lg border border-white/12 bg-black/40 px-2 py-1 text-[12px] text-white/85">
        <option value="OUT">OUT</option><option value="DOUBT">DOUBT</option><option value="AVAILABLE">AVAILABLE</option>
      </select>
      <button type="submit" disabled={busy || !player.trim()} data-testid="team-news-apply" className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-[11px] font-semibold text-black disabled:opacity-40">
        {busy ? <Loader2 size={12} className="animate-spin" /> : null} Apply & re-price
      </button>
      <button type="button" onClick={() => setOpen(false)} data-testid="team-news-close" aria-label="Close team news" className="rounded-full p-1 text-white/40 hover:text-white"><X size={13} /></button>
    </form>
  );
};
